var exports = {
  "w": "TimeoutMemberSheet.module__header___Tmpad2",
  "h": "TimeoutMemberSheet.module__description___Tmpad2",
};

module.exports = exports;
